import React, { FC, useRef, useState } from "react";
import TextFieldMask from "ui/TextFieldMask/TextFieldMask";
import Button from "ui/Button/Button";
import { useFormController } from "common/FormSystem";
import { useStore } from "store";
import { useApi } from "services/ApiService";
import { getErrorCode, getErrorMessage } from "helpers/errors";
import { useForceUpdate } from "helpers/hooks";
import { plainPhone } from "helpers/text";
import styles from "../../ProductArrivalModal.module.scss";

type Props = {
  productId: Entity.Product["id"];
  onClose: () => void;
};

const EmailForm: FC<Props> = ({ productId, onClose }: Props) => {
  const forceUpdate = useForceUpdate();
  const error = useRef(null);
  const [submitting, setSubmitting] = useState(false);

  const {
    methods: { product },
  } = useApi();
  const { user, notifications, location } = useStore();

  const initFormState = [
    {
      id: "PHONE",
      typeControl: "INPUT",
      label: "Ваш телефон",
      value: user.profile?.phone || "",
      isDirty: false,
      rules: [
        {
          validator: () => {
            return !error.current;
          },
          message: () => getErrorMessage(error.current),
        },
        {
          validator: value => {
            return value && value !== "";
          },
          message: () => "Поле обязательно",
        },
      ],
    },
  ];

  const onSubmit = e => {
    e && e.preventDefault();

    if (submitting) return;

    setSubmitting(true);

    try {
      submitForm(async () => {
        const params = {
          ID: productId,
          phone: plainPhone(getControl("PHONE").value),
          regionCode: location.regionID,
        };

        const { errors } = await product.setDrugNotify({ params });

        setSubmitting(false);

        if (errors?.length > 0) {
          error.current = getErrorCode(errors[0].message);
          forceUpdate();
        } else {
          onClose && onClose();
        }
      });
    } catch (err) {
      setSubmitting(false);

      notifications.show({
        type: "toast",
        props: {
          title: "Ошибка запроса",
          children: "Попробуйте позже",
        },
      });
    }
  };

  const formChange = () => {
    error.current = "";
    setSubmitting(false);
  };

  const { getControl, getError, onChangeValue, submitForm } = useFormController(
    initFormState,
    { onChange: formChange }
  );

  return (
    <form className={styles.productArrivalInner} onSubmit={onSubmit}>
      <TextFieldMask
        placeholder={getControl("PHONE").label}
        label="Ваш телефон"
        mask="+7 (999) 999 99 99"
        maskChar=""
        value={getControl("PHONE").value}
        onChange={e => onChangeValue(e.target.value, "PHONE")}
        error={getError("PHONE")}
        type="tel"
        autoFocus
      />

      <Button orange fluid type="submit" disabled={submitting}>
        Сообщить о поступлении
      </Button>
    </form>
  );
};

export default EmailForm;
